import { type ComponentProps, type ReactElement, type ReactNode } from 'react';
import { Text } from './Text';
import type { SxProps, Theme } from './types';

type PanelHeadingTextProps = {
  children: ReactNode;
  color?: ComponentProps<typeof Text>['color'];
  component?: ComponentProps<typeof Text>['component'];
  sx?: SxProps<Theme>;
};

export const PanelHeadingText = ({
  children,
  color = 'textSecondary',
  component,
  sx,
}: PanelHeadingTextProps): ReactElement => {
  const baseSx: SxProps<Theme> = {
    fontSize: '13px',
    fontWeight: 500,
  };
  const resolvedSx = sx ? [baseSx, ...(Array.isArray(sx) ? sx : [sx])] : baseSx;

  return (
    <Text role="label" color={color} component={component} sx={resolvedSx}>
      {children}
    </Text>
  );
};
